import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HintWithIndicatorModule } from './indicator';
import { HintsPopupModule } from './popup';
import { HintsSimpleModule } from './simple';

import { HintsTypesComponent } from './hints-types.shared.component';

const toExport: any[] = [
    HintWithIndicatorModule,
    HintsPopupModule,
    HintsSimpleModule,
];

@NgModule({
    declarations: [
        HintsTypesComponent,
    ],
    imports: [
        CommonModule,
        ...toExport
    ],
    exports: [
        HintsTypesComponent,
        ...toExport
    ],
})
export class HintTypesModule { }
